import Api from 'services/api';

export const speechToText = async (formData: FormData) => {
  const response = await Api.post(
    '/chatbots/chatbot_assistant/assistant_user_chat_messages/audio',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

export const textToSpeech = async (text: string) => {
  const response = await Api.post(
    '/chatbots/chatbot_assistant/assistant_user_chat_messages/text_to_speech',
    { text },
    { responseType: 'blob' },
  );

  if (typeof response.status === 'number' && (response.status < 200 || response.status >= 300)) {
    throw new Error(`text_to_speech: HTTP ${response.status}`);
  }

  const blob = response.data as Blob;
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error('text_to_speech: resposta vazia ou inválida');
  }

  return blob;
};
